export var WorkerMessageType;
(function (WorkerMessageType) {
    WorkerMessageType[WorkerMessageType["Data"] = 0] = "Data";
})(WorkerMessageType || (WorkerMessageType = {}));
